export const heroMetrics = [
  { value: '$550K', label: 'Client Month', delay: '0s' },
  { value: '$500K+', label: 'Record Month', delay: '0.8s' },
  { value: '200%', label: 'Above Goal', delay: '1.6s' },
  { value: '1:12', label: 'Historical ROI Benchmark', delay: '2.4s' },
];

export const featuredStats = [
  { value: '200%', label: 'Above Goal' },
  { value: '$500K+', label: 'Record Client Month' },
  { value: '$550K', label: 'Client Month' },
  { value: '1:12', label: 'Historical Marketing + Ad Spend Benchmark' },
];

export const resultsGrid = [
  {
    industry: 'Roofing',
    result: '$500K+',
    title: 'Record Month',
    summary:
      'A client reached a record monthly revenue milestone after improving their marketing and growth systems.',
    type: 'Strategy + Systems',
    quote: 'We finally know exactly what our marketing dollars are doing.',
  },
  {
    industry: 'Home Services',
    result: '$550K',
    title: 'Client Month',
    summary:
      'A business reported one of its strongest months after improving its acquisition and marketing strategy.',
    type: 'Acquisition + Strategy',
    quote: 'The quality of leads is night and day.',
  },
  {
    industry: 'HVAC',
    result: '200%',
    title: 'Above Goal',
    summary:
      'A client exceeded their target by approximately 200% after a rebuilt lead and follow-up system.',
    type: 'Lead Generation',
    quote: 'The pipeline is predictable now.',
  },
  {
    industry: 'Local Service',
    result: 'Better Lead Flow',
    title: 'More Predictable Acquisition',
    summary:
      'More predictable customer acquisition with a steady stream of qualified, ready-to-buy prospects.',
    type: 'Lead Systems',
    quote: 'We stopped chasing jobs and started choosing them.',
  },
  {
    industry: 'Home Services',
    result: 'Improved Follow-Up',
    title: 'Stronger CRM & Nurturing',
    summary:
      'Stronger CRM and lead nurturing systems that turn missed calls into booked service and revenue.',
    type: 'CRM + Automation',
    quote: 'Missed calls became booked service. It changed our season.',
  },
  {
    industry: 'Local Service',
    result: 'Better Visibility',
    title: 'Clearer Tracking & Decisions',
    summary:
      'Clearer tracking, systems, and decision-making so owners can see exactly what is and is not working.',
    type: 'Measurement',
    quote: 'We finally see the whole picture, not just ad clicks.',
  },
];

export const improvements = [
  {
    icon: 'ri-compass-3-line',
    title: 'Strategy',
    desc: 'Clearer positioning, offers, targeting, and priorities.',
  },
  {
    icon: 'ri-window-line',
    title: 'Website & Funnel',
    desc: 'Improve conversion paths and lead capture.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Paid Acquisition',
    desc: 'Better ad strategy and campaign structure.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'CRM & Automation',
    desc: 'Reduce missed leads and improve follow-up.',
  },
  {
    icon: 'ri-service-line',
    title: 'Sales Process',
    desc: 'Strengthen how inquiries become customers.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Measurement',
    desc: 'Track the metrics that actually matter.',
  },
];

export const testimonials = [
  {
    quote:
      'Josh is not a typical marketer. He thinks like a business owner and measures everything in revenue, not impressions.',
    name: 'Daniel R.',
    business: 'Residential Roofing Co.',
    industry: 'Roofing',
    tag: 'Exceeded Goal',
  },
  {
    quote:
      'The numbers on paper were one thing — the actual results were even better. We hit the benchmark within months.',
    name: 'Sarah M.',
    business: 'Regional HVAC',
    industry: 'HVAC',
    tag: 'Record Month',
  },
  {
    quote:
      'From strategy to execution, he made our internal team look better and our numbers prove it.',
    name: 'Mike T.',
    business: 'Outdoor Living Co.',
    industry: 'Hardscaping',
    tag: 'Better Lead Flow',
  },
  {
    quote:
      'Clear, honest, and results-driven.Josh told us what would work, what would not, and delivered on the rest.',
    name: 'Lauren K.',
    business: 'Home Services Group',
    industry: 'Home Services',
    tag: 'More Predictable Growth',
  },
];

export const videos = [
  {
    name: 'Daniel R.',
    business: 'Residential Roofing Co.',
    summary: '200% above annual goal within the first year.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20business%20owner%20in%20workwear%20standing%20confidently%20on%20a%20residential%20rooftop%20at%20golden%20hour%2C%20cinematic%20depth%20of%20field%2C%20warm%20editorial%20photography%20with%20subtle%20teal%20tone%20grading%2C%20premium%20testimonial%20video%20thumbnail%20style%2C%20high%20detail%2C%20approachable%20and%20trustworthy&width=960&height=600&seq=results-video-roofing&orientation=landscape',
  },
  {
    name: 'Sarah M.',
    business: 'Regional HVAC',
    summary: 'A record month with over $500K in revenue.',
    image:
      'https://readdy.ai/api/search-image?query=Confident%20female%20business%20manager%20in%20a%20modern%20office%20overlooking%20an%20HVAC%20service%20facility%2C%20soft%20window%20light%2C%20cinematic%20editorial%20photography%20with%20subtle%20teal%20tone%20grading%2C%20premium%20testimonial%20video%20thumbnail%20style%2C%20high%20detail%2C%20professional%20and%20trustworthy&width=960&height=600&seq=results-video-hvac&orientation=landscape',
  },
  {
    name: 'Mike T.',
    business: 'Outdoor Living Co.',
    summary: 'A $550K month with predictable lead flow.',
    image:
      'https://readdy.ai/api/search-image?query=Outdoor%20living%20and%20hardscaping%20business%20owner%20standing%20beside%20a%20beautifully%20finished%20stone%20patio%20project%20at%20dusk%2C%20warm%20ambient%20lighting%2C%20cinematic%20editorial%20photography%20with%20subtle%20teal%20tone%20grading%2C%20premium%20testimonial%20video%20thumbnail%20style%2C%20high%20detail&width=960&height=600&seq=results-video-hardscape&orientation=landscape',
  },
];

export const beforeItems = [
  'Inconsistent lead flow',
  'No clear marketing attribution',
  'Slow lead follow-up',
  'Campaigns operating separately',
  'Unclear ROI',
  'Owner making reactive decisions',
];

export const afterItems = [
  'More predictable lead generation',
  'Better tracking',
  'Faster follow-up',
  'Connected marketing systems',
  'Clearer performance visibility',
  'Better strategic decisions',
];
